module.exports = {"name":"newDirectory","audiences":["allMembers"],"experimentAllocation":1,"defaultWeight":0.99,"experimentVersion":"v1","defaults":{"enabled":false},"autoTrack":true,"variations":[{"name":"enabled","weight":0.01,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/newDirectory.json
// module id = 6ktd
// module chunks = 0